
import React, { FormEvent, useCallback, useContext, useEffect, useMemo, useState } from 'react'
import RegisterOscContext from '../../../context/RegisterContext'
import useApi from '../../../hooks/useApi'
import { SubmitButton } from '../../../Korbantech/components/Buttons/SubmitButton'
import { Osc } from '../../../types/Osc'
import { SuccessAlert } from '../../Alerts/SuccessAlert'
import { SpinnerLoad } from '../../Loading/SpinnerLoad'
import { CnpjInput } from '../OscInputs/CnpjInput'
import { OscInput } from '../OscInputs/OscInput'
import { LocationFields } from './LocationFields'
import { ResponsibleFields } from './ResponsibleFields'

export const GeneralDataFields = ({ oldData ,update, isPublic}: Props) => {

    const api = useApi()

    const [load,setLoad] = useState<boolean>(false)
    const { setStep } = useContext(RegisterOscContext)
    const { osc , setOsc} = useContext(RegisterOscContext)
    const [newData , setNewData] = useState<Osc|undefined>(undefined)
    const [isSuccess,setIsSuccess] = useState<boolean>(false)


    const handleSubmit = useCallback(async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        e.currentTarget.checkValidity()

        setLoad(true)
        if (!e.currentTarget) return
        const data = new FormData(e.currentTarget)

        if(!update && osc ) return setStep(2)

        if (update && osc) {
            setLoad(true)
            data.append('_method', 'PATCH')
            if (isPublic){
                await api.post(`/client/me/`, data).then(res => {
                    setNewData(res.data);
                    setIsSuccess(true)
                }).catch(console.log)
            }else {
                await api.post(`admin/osc/${osc.id}/update`, data).then(res => {
                    setNewData(res.data);
                    setIsSuccess(true)
                }).catch(console.log)
            }
            setLoad(false)
            return
        }

        await api.post("/osc", data).then(res => {
            setOsc(res.data)
            setStep(2)
        }).catch(err => {

        })
        setLoad(false)

    }, [api, setStep , osc , setOsc,setIsSuccess , setLoad , update, isPublic])

    const data = useMemo(():Osc | undefined=>{

        let data:Osc|undefined = undefined

        if(osc) data = osc

        if(oldData) data = oldData

        if(newData) data = newData

        return data

    },[oldData,osc,newData])

    useEffect(()=>{
        if(osc) setStep(2);
    },[osc,setStep])

    return (
        <>
            {isSuccess && <SuccessAlert message='Alterado' closeAlert={()=>setIsSuccess(false)}/>}
            {oldData && <div className='font-semibold text-xl mb-2'>Dados gerais</div>}

            <form onSubmit={handleSubmit} className={`flex flex-col mb-10 ${data && 'border-l-4 border-green-600 pl-4 pr-4 rounded-lg '}`}>
                <div className='grid gap-x-6 gap-y-2 grid-cols-1 md:grid-cols-2 text-gray-800 '>

                    <CnpjInput cad={!data && true} label={'CNPJ'} necessary name='document' type={'cnpj'} defaultValue={data && data.document}  />

                    <OscInput label={'Data de fundação da instituição (consta no CNPJ)'}
                        necessary name='fundation_date' type={'date'} defaultValue={data && data.fundation_date}
                        required
                    />

                    <OscInput
                        label={'Razão Social'} name='corporate_name' defaultValue={data && data.corporate_name} necessary required/>

                    <OscInput label={'Nome Fantasia'} name={"fantasy_name"} defaultValue={data && data.fantasy_name} />
                </div>
                <LocationFields locationOld={data?.location} />
                <ResponsibleFields responsible={data?.responsible} />

                {!data &&
                    <div className='grid gap-x-6 gap-y-2 grid-cols-1 md:grid-cols-2 text-gray-800 mt-6 '>
                        <OscInput label={'Senha'} type="password" name='password' minlength="4"
                            info={" Mínimo de 4 caracteres. Essa senha será utilizada para que você possa acessar o sistema posteriormente"}
                            necessary required />
                        <OscInput label={'Confirmar senha'} type="password" name='password_confirmation' necessary required />
                    </div>
                }
                <div className='flex justify-between mt-2 p-4'>
                <div className='w-2/12 self-end mt-2'>

                </div>
                <div className='w-2/12 self-end mt-2'>
                    {!load && <>
                    {!update ?
                    <SubmitButton value={osc ? "Continuar" : "Proximo"} />
                    : <SubmitButton value="Atualizar"/>
                    }
                    </>
}
                   {load && <SpinnerLoad/>}
                </div>
                </div>


            </form>

        </>
    )
}

interface Props {
    oldData?:Osc
    update?:boolean
    isPublic?:boolean
}
